export default __webpack_public_path__ + "static/media/aeroparque.de323952.svg";